import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative md:ltr:pl-[25px] md:ltr:first:pl-0 md:rtl:pr-[25px] md:rtl:first:pr-0 md:ltr:-mr-[25px] md:rtl:-ml-[25px] md:ltr:first:mr-0 md:rtl:first:ml-0 mt-[20px] sm:mt-0 first:mt-0" }
const _hoisted_2 = { class: "absolute -top-[28px] ltr:-right-[9px] rtl:-left-[9px] max-w-[120px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "block" }, " Website Visits ", -1)),
    _cache[1] || (_cache[1] = _createElementVNode("h5", { class: "mb-0 mt-[3px] text-[20px]" }, "215.2k", -1)),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isClient)
        ? (_openBlock(), _createBlock(_component_apexchart, {
            key: 0,
            type: "area",
            height: "95",
            options: _ctx.realtimeActiveUsers,
            series: _ctx.realtime
          }, null, 8, ["options", "series"]))
        : _createCommentVNode("", true)
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "mt-[12px] flex items-center justify-between" }, [
      _createElementVNode("span", { class: "inline-block text-xs text-success-700 px-[9px] border border-success-300 bg-success-100 rounded-xl" }, " +10% Increase "),
      _createElementVNode("span", { class: "block text-xs" }, " Last 7 days ")
    ], -1))
  ]))
}